type Props = {};

export default function Inbox({}: Props) {
  return (
    <div>
      <div className="flex h-screen w-full flex-col">
        <div className="flex h-12 items-center justify-between border-b border-gray-200/70 px-8">
          <div className="text-sm text-gray-800">Inbox</div>
        </div>
        <div className="flex flex-1 overflow-auto">
          <div className="w-96 border-r border-gray-200/70 p-6">
            {/* List of inbox items goes here */}
          </div>
          <div className="flex-1 p-6">
            {/* Content of the selected inbox item goes here */}
          </div>
        </div>
      </div>
    </div>
  );
}
